<template>
  <div class="header align-items-center">
    <div @click="openNav" class="header__menu-toggle d-inline-flex d-lg-none">
      <b-icon-list></b-icon-list>
    </div>
    <div class="header__search">
      <search />
    </div>
    <div class="header__user">
      <user />
    </div>
  </div>
</template>

<script>
import user from "./header-user.vue";
import search from "./header-search.vue";
export default {
  components: {
    user,
    search,
  },
  data() {
    return {
      openNavEvent: null,
    };
  },
  methods: {
    openNav() {
      window.dispatchEvent(this.openNavEvent);
    },
  },
  mounted() {
    const openNav = new CustomEvent("openNav");
    this.openNavEvent = openNav;
  },
};
</script>

<style lang="scss" scoped>
.header {
  border-radius: 6px;
  min-height: 42px;
  margin-bottom: 30px;
  display: flex;
  &__menu-toggle {
    font-size: 36px;
    margin-right: 12px;
    padding: 0px 6px;
    height: 42px;
    width: 42px;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    padding-top: 2px;
    border-radius: 50%;
    color: var(--primary-color);
    cursor: pointer;
    transition: 0.3s;
    &:hover {
      transition: 0.3s;
      background: rgba(#ccc, 0.5);
    }
  }
  &__search {
    padding-right: 10px;
  }
  &__user {
    margin-left: auto;
  }
}
</style>
